<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.pdTechDictStatus === 'N' ? 'danger' : 'success'"
        >
          {{ row.v_pdTechDictStatus }}
        </el-tag>
      </template>
      <template v-slot:creator="{ row }">
       <div> {{ row.createByName }}</div>
       <div> {{ row.createTime }}</div>
      </template>
       <template v-slot:modified="{ row }">
       <div> {{ row.modifyByName }}</div>
       <div> {{ row.modifyTime }}</div>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ ...opt, row }"
                :divided="opt.divided"
                :disabled="
                  opt.status && opt.status.length
                    ? !opt.status.includes(row.pdTechDictStatus)
                    : false
                "
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      title="工艺信息"
      :visible.sync="pTechnicalInfoVisible"
      show-close
      width="600px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <process-technical-detail
        :pdTechDictCode="pdTechDictCode"
        :disabled="detailDisabled"
        @closeDetail="closeDetail"
      ></process-technical-detail>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import processTechnicalDetail from '../../detail'
import tableColumns from './table-columns'
import tableOpts from './table-opts'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {processTechnicalDetail},
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      pdTechDictCode: '',
      pTechnicalInfoVisible: false,
      detailDisabled: false,
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ menuType, row }) {
      if (!menuType) return

      const { pdTechDictCode } = row

      switch (menuType) {
        case 'detail':
          this.pdTechDictCode = pdTechDictCode
          this.detailDisabled = true
          this.pTechnicalInfoVisible = true
          break
        case 'edit':
          this.pdTechDictCode = pdTechDictCode
          this.detailDisabled = false
          this.pTechnicalInfoVisible = true
          break
        case 'delete':
          this.del(row)
          break
      }
    },
    closeDetail() {
      this.pTechnicalInfoVisible = false
      this.$emit("reload")
    },
    del({ pdTechDictCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm'),
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .pdTechDictionaryDelApi({ pdTechDictCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
